const STORAGE_KEY = 'urunn_onboarding_data';

export const saveOnboardingAnswers = (answers: Record<string, any>): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(answers));
  } catch (error) {
    console.error('[OnboardingStorage] Failed to save answers:', error);
  }
};

export const loadOnboardingAnswers = (): Record<string, any> | null => {
  try {
    const data = sessionStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('[OnboardingStorage] Failed to load answers:', error);
    return null;
  }
};

export const isOnboardingCompleted = (): boolean => {
  const answers = loadOnboardingAnswers();
  return answers !== null && Object.keys(answers).length > 0;
};

export const clearOnboardingAnswers = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('[OnboardingStorage] Failed to clear answers:', error);
  }
};
